import {Box3,Vector3,type Camera,type Object3D} from 'three';
/** Screen-sized target: stays usable as the room zooms out. */
export function beddingTouchDistance(object:Object3D,camera:Camera,width:number,height:number,x:number,y:number){
 const box=new Box3().setFromObject(object);if(box.isEmpty())return Infinity;
 let left=Infinity,right=-Infinity,top=Infinity,bottom=-Infinity;
 for(const a of [box.min.x,box.max.x])for(const b of [box.min.y,box.max.y])for(const c of [box.min.z,box.max.z]){
  const p=new Vector3(a,b,c).project(camera);if(p.z< -1||p.z>1)return Infinity;
  const px=(p.x+1)*width/2,py=(1-p.y)*height/2;left=Math.min(left,px);right=Math.max(right,px);top=Math.min(top,py);bottom=Math.max(bottom,py);
 }
 const padX=Math.max(12,(44-(right-left))/2),padY=Math.max(12,(44-(bottom-top))/2);
 if(x<left-padX||x>right+padX||y<top-padY||y>bottom+padY)return Infinity;
 return Math.hypot(Math.max(left-x,0,x-right),Math.max(top-y,0,y-bottom));
}
